import createIcon from '../../createIcon';

/**
 * @component @name ViewStream
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxN1YxNUMzIDEzLjkgMy45IDEzIDUgMTNIMTlDMjAuMSAxMyAyMSAxMy45IDIxIDE1VjE3QzIxIDE4LjEgMjAuMSAxOSAxOSAxOUg1QzMuOSAxOSAzIDE4LjEgMyAxN1pNMyA3VjlDMyAxMC4xIDMuOSAxMSA1IDExSDE5QzIwLjEgMTEgMjEgMTAuMSAyMSA5VjdDMjEgNS45IDIwLjEgNSAxOSA1SDVDMy45IDUgMyA1LjkgMyA3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewStream = createIcon('ViewStream', [
  [
    'path',
    {
      d: 'M3 17V15C3 13.9 3.9 13 5 13H19C20.1 13 21 13.9 21 15V17C21 18.1 20.1 19 19 19H5C3.9 19 3 18.1 3 17ZM3 7V9C3 10.1 3.9 11 5 11H19C20.1 11 21 10.1 21 9V7C21 5.9 20.1 5 19 5H5C3.9 5 3 5.9 3 7Z',
      key: '1ce8p0',
    },
  ],
]);

export default ViewStream;
